import { RouteObject } from 'react-router';

import { ROUTES } from '~shared/routes';

export const promotions: RouteObject[] = [
  {
    path: ROUTES.promotions.root,
    lazy: async () => {
      const { PromotionPage } = await import('../../pages/promotions');

      return { Component: PromotionPage };
    },
  },
  {
    path: ROUTES.promotions.new,
    lazy: async () => {
      const { PromotionFormPage } = await import('../../pages/promotions');

      return { Component: PromotionFormPage };
    },
  },
  {
    path: ROUTES.promotions.edit,
    lazy: async () => {
      const { PromotionFormPage } = await import('../../pages/promotions');

      return { Component: PromotionFormPage };
    },
  },
  {
    path: ROUTES.promotions.copy,
    lazy: async () => {
      const { PromotionFormPage } = await import('../../pages/promotions');

      return { Component: PromotionFormPage };
    },
  },
];
